import { render, staticRenderFns } from "./WatchList.vue?vue&type=template&id=26f306d8&scoped=true&"
import script from "./WatchList.vue?vue&type=script&lang=ts&"
export * from "./WatchList.vue?vue&type=script&lang=ts&"
import style0 from "./WatchList.vue?vue&type=style&index=0&id=26f306d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f306d8",
  null
  
)

export default component.exports